module.exports = __webpack_public_path__ + "img/library.66aff986.jpg";